import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import TabPayroll from "./TabPayroll";
import TabPayrollTemplates from "./TabPayrollTemplates";

import { tr } from "../../i18n";
const PayrollPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Ambil tab dari URL, default ke "attendance"
  const activeTab = searchParams.get("tab") || "payroll";

  // Fungsi ganti tab
  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };

  return (
    <div className="mt-5">
      {/* Tabs */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "payroll" ? "active" : ""}`}
            onClick={() => handleTabChange("payroll")}
          >
            {tr("common:menu.payroll")}
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "template" ? "active" : ""}`}
            onClick={() => handleTabChange("template")}
          >
            {tr("payroll:template_payroll")}
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="box-shadow nb-top">
        {activeTab === "payroll" && <TabPayroll />}
        {activeTab === "template" && <TabPayrollTemplates />}
      </div>
    </div>
  );
};

export default PayrollPage;
